import { defineStore } from 'pinia';

export const useToastStore = defineStore('toast', {
  state: () => ({ toast: null }),

  actions: {
    show(toastProps) {
      this.toast = toastProps;
    },

    hide() {
      this.toast = null;
    },
  },
});
